module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-list widget",
    attrs: {
      "id": "chat-list"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Think Tank Chat "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Realtime instant messaging'),
      expression: "'Realtime instant messaging'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.openChat()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a7f7856!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/RocketChat.vue
// module id = 1995
// module chunks = 2